
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-chat-enhancement-demo-think","docs-x-markdown-chat-enhancement-demo-sources"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/chat-enhancement.zh-CN.md?type=demo')
};